import { Trans, useLingui } from "@lingui/react/macro";
import { useState } from "react";

import { apiPutAuthRequestTokenLogin } from "../../../api";
import { RequestError } from "../../../api/api-connector";
import { genericErrorMsg } from "../../../app/common-messages";
import { Button } from "../../../components/ui-kit/button";
import { ErrorMessage } from "../../../components/ui-kit/error-message";
import { TextInput } from "../../../components/ui-kit/fields/text-input";
import { Form } from "../../../components/ui-kit/form/form";
import { SuccessMessage } from "../../../components/ui-kit/success-message";

export function EmailLogin(props: { onBack: () => void }) {
  const { t } = useLingui();
  const [email, setEmail] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  async function handleSubmit() {
    setSuccessMessage("");
    setErrorMessage("");

    try {
      await apiPutAuthRequestTokenLogin({
        query: { user_email: email },
      });

      setSuccessMessage(
        t`A login link has been sent to your email. Please check your inbox.`,
      );
      setEmail("");
    } catch (error) {
      if (error instanceof RequestError) {
        if (error.response.status === 429) {
          setErrorMessage(
            t`A login link was already requested recently. Please wait a few minutes before trying again.`,
          );
        } else {
          setErrorMessage(t(genericErrorMsg));
        }
      } else {
        throw error;
      }
    }
  }

  return (
    <Form className="flex flex-col" onSubmit={handleSubmit}>
      <div className="grid grid-cols-[max-content_1fr] gap-x-2 gap-y-3 items-center">
        <label>
          <Trans>Email:</Trans>
        </label>
        <TextInput
          type="email"
          value={email}
          onChange={(newValue) => {
            setEmail(newValue);
          }}
          required
          autoFocus
        />
      </div>

      <ErrorMessage message={errorMessage} />
      <SuccessMessage message={successMessage} />

      <div className="flex items-center justify-between mt-6">
        <a
          onClick={props.onBack}
          className="text-xs text-brand-primary hover:underline cursor-pointer"
        >
          <Trans>Back</Trans>
        </a>

        <Button variant="primary" type="submit">
          <Trans>Send login link</Trans>
        </Button>
      </div>
    </Form>
  );
}
